import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeader } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { PaginationService } from 'projects/Administration/src/app/services/pagination.service';
import { PagerData } from 'projects/Administration/src/app/business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Filter } from 'projects/Administration/src/app/business-entities/Filter';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ToweinUseService } from '../../../../business-services/towein-use.service';
import { ToweInDealersModal } from 'projects/Administration/src/app/business-entities/towed-in-report-model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-towedin-dealer-details',
  templateUrl: './towedin-dealer-details.component.html',
})
export class TowedinDealerDetailsComponent implements OnInit {
  //#region Variable Declaration
  toweInDealerList: ToweInDealersModal[];
  dataList: ToweInDealersModal[] = [];
  dealerList = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  debounceTimer;
  @Input() dealerId;
  @Input() dealerName;
  @Input() selectedDate;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  //#endregion

  //#region Constructor
  constructor(
    private spinner: NgxSpinnerService,
    private activeModal: NgbActiveModal,
    private pagerService: PaginationService,
    private toweinUseService: ToweinUseService,
    private excelService: ExcelService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) { }
  //#endregion
  ngOnInit() {
    this.toweinUseService.toweinDealerListRequest.startRecordNumber = 0;
    this.dealerList = this.toweinUseService.dealerList;
    this.toweInDealerList = [];
    this.toweinUseService.toweinDealerListRequest.dealerId = this.dealerId;
    this.toweinUseService.toweinDealerListRequest.selectedDate = this.selectedDate;
    this.getToweInUsageDealerList();
  }

  //#region Component Methods

  onRefreshClick() {
    this.toweInDealerList = [];
    this.getToweInUsageDealerList();
  }

  async getToweInUsageDealerList() {
    this.spinner.show();
    await this.toweinUseService.getToweInUsageDealerWiseList(this.toweinUseService.toweinDealerListRequest)
      .then(
        (response) => {
          this.spinner.hide();
          this.toweInDealerList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            if (this.toweInDealerList?.length > 0) {
              this.toweInDealerList?.forEach(x => {
                if (x?.createdDate) {
                  x.createdDate = x.createdDate ? new Date(x.createdDate + 'Z') : null;
                }
              })
            }
            this.totalCount =
              this.toweInDealerList.length > 0
                ? this.toweInDealerList[0].totalCount
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.toweInDealerList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  loadMoreData(event) {
    this.debounceFunction(() => this.onScrollDown(event), 200);
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.toweInDealerList?.length) {
      this.toweinUseService.toweinUserListRequest.startRecordNumber = this.toweInDealerList.length
      this.getToweInUsageDealerList();
    }
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
  //#endregion

  //#region Export Methods
  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblTowedInReport')}_${this.dealerName}`);
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('portrait');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 14 },
        1: { cellWidth: 25 },
        2: { cellWidth: 25 },
        3: { cellWidth: 35 },
        4: { cellWidth: 45 },
        5: { cellWidth: 30 },
        6: { cellWidth: 30 },
      }
    });
    doc.save(`${this.translate.instant('lblTowedInReport')}_${this.dealerName}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.toweinUseService.toweinDealerListRequest.isExport = true;
    await this.toweinUseService.getToweInUsageDealerWiseList(this.toweinUseService.toweinDealerListRequest).then((res) => {
      if (!res || res.responseObject.length === 0) {
        this.toastr.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.toweinUseService.toweinDealerListRequest.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblWoNo')]: item.workOrderNo,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblModel')]: item.modelName,
      [this.translate.instant('lblCustomer')]: item.customerName,
      [this.translate.instant('lblCreatedDate')]: item.createdDate ? this.datePipe.transform(new Date(item.createdDate + 'Z'), 'dd-MM-yyyy HH:mm', '') : null,
      [this.translate.instant('lblCustomerMobile')]: item.customerMobile,
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblModel'),
      this.translate.instant('lblCustomer'),
      this.translate.instant('lblCreatedDate'),
      this.translate.instant('lblCustomerMobile'),
    ];
  }
}
//#endregion